<template>
  <div class="home">
    <pageTop></pageTop>
<!--    <div class="block-box-en bfc block-box bfc bag-top evaluate-top">-->
<!--      <div class="mark"></div>-->
<!--      <div class="title po-not-static">-->
<!--        <img src="@/assets/images/07.png" style="width: 500px;">-->

<!--        <div class="top_menu_03"></div>-->
<!--        <img src="@/assets/images/06.png"  style="width: 160px;">-->
<!--        <section class="demo" id="bottom">-->
<!--          <a onclick="scrollDown()"><span></span></a>-->
<!--        </section>-->
<!--      </div>-->

<!--    </div>-->
    <div ref="banner" class="banner content-item-block">
      <div class="video-wrapper">
<!--        <video-->
<!--          class="video"-->
<!--          preload="auto"-->
<!--          muted-->
<!--          loop-->
<!--          playsinline-->
<!--          autoplay-->
<!--          poster="//juanxiuhe.oss-cn-beijing.aliyuncs.com/web/bannerbg.jpg"-->
<!--          src="//juanxiuhe.oss-cn-beijing.aliyuncs.com/dibao/home.mp4"-->
<!--          tabindex="-1"-->
<!--        ></video>-->


        <video
            class="video"
            preload="auto"
            muted
            loop
            playsinline
            autoplay
            poster="//juanxiuhe.oss-cn-beijing.aliyuncs.com/web/bannerbg.jpg"
            src="//juanxiuhe.oss-cn-beijing.aliyuncs.com/dibao/home.mp4"
            tabindex="-1"
        ></video>

      </div>
      <h1 class="banner-title">

        专注直播,奔赴热爱
        <div class="subTitle">JOIN EAST·DB</div>
      </h1>
      <div class="search">
        <img  @click="searchJobs" src="@/assets/images/06.png" style="width: 160px;">
<!--        <input-search @search="searchJobs" size="small" placeholder="输入城市或职位进行搜索"></input-search>-->
      </div>
      <div class="arrow-down" @click="scrollDown()"></div>

      <!--      <div class="bottom-tips">-->
<!--        <span class="arrow-down" @click="scrollDown">-->
<!--          <i>⤓</i>-->
<!--        </span>-->
<!--        <span class="vertical-dashed"></span>-->
<!--      </div>-->
    </div>

    <div class="block-box estimate flex flex-c flex-col">


      <div class="block-box bfc pr estimate-res padyx36 mtb36">
        <div class="title po-not-static font-theme-c">
          <h2 class="mb16 fonts-28 font-w">招聘岗位</h2>
          <h6 class="fonts-16">RECRUITMENT POSITION</h6>
        </div>

        <div class="notice mt56">
          <div class="figure-box">
            <div class="title">
              <img src="@/assets/images/round.png"/>
              <span>01</span>
            </div>
            <p>主播</p>
          </div>
          <div class="figure-box">
            <div class="title">
              <img src="@/assets/images/round.png"/>
              <span>02</span>
            </div>
            <p>财务</p>
          </div>
          <div class="figure-box">
            <div class="title">
              <img src="@/assets/images/round.png"/>
              <span>03</span>
            </div>
            <p>研发</p>
          </div>
          <div class="figure-box">
            <div class="title">
              <img src="@/assets/images/round.png"/>
              <span>04</span>
            </div>
            <p>人事</p>
          </div>
          <div class="figure-box">
            <div class="title">
              <img src="@/assets/images/round.png"/>
              <span>05</span>
            </div>
            <p>行政</p>
          </div>
        </div>
      </div>

      <div class="block-box bfc pr estimate-res padyx36 mb36">
        <div class="title po-not-static font-theme-c">
          <h2 class="mb16 fonts-28 font-w">直播主播</h2>
          <h6 class="fonts-16">LIVE STREAMER</h6>
        </div>

        <div class="num-col mt56">
          <div class="row">
            <img src="@/assets/images/num.png"/>
            每天直播按时上线、稳定上线、固定直播时长。
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            通过直播向粉丝介绍商品，推荐商品买点，引导粉丝完成购买流程。
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            解答粉丝的疑惑，活跃聊天气氛，与粉丝形成良好的互动。
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            18到30岁，积极向上(有美妆直播经验优先)
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            五官端正，形象气质佳，自信阳光，不惧怕镜头。
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            认真负责、有亲和力、有耐心、沟通能力强、能高效完成相关工作。
          </div>

        </div>



        <div class="title po-not-static font-theme-c">
          <h2 class="mb16 fonts-28 font-w">主播运营</h2>
          <h6 class="fonts-16">ANCHOR OPERATION</h6>
        </div>

        <div class="num-col mt56">
          <div class="row">
            <img src="@/assets/images/num.png"/>
            负责各平台直播间的搭建，对直播画面优化
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            监控直播间主播产品讲解，对直播间的话术、弹幕回复、视觉效果、设备异常进行及时调整优化
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            完成领导交代的其他临时性任务；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            有搭建直播间经营者优先
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            有1年以上独立运营行业相关工作；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            思维敏捷、性格外向、有较强的执行力和沟通协调能力；
          </div>

        </div>




        <div class="title po-not-static font-theme-c">
          <h2 class="mb16 fonts-28 font-w">财务会计</h2>
          <h6 class="fonts-16">FINANCIAL ACCOUNTING</h6>
        </div>

        <div class="num-col mt56">
          <div class="row">
            <img src="@/assets/images/num.png"/>
            本科及以上学历，会计、财务管理等相关专业
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            一年以上大中型企业会计工作经验者优先；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            熟练操作OFFICE办公软件； 熟悉国家相关法律法规；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            负责日常费用审核和账务处理；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            负责年度费用预算审核；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            按期出具财务报表及其他管理报表；
          </div>

        </div>



        <div class="title po-not-static font-theme-c">
          <h2 class="mb16 fonts-28 font-w">人力资源专员</h2>
          <h6 class="fonts-16">HUMAN RESOURCES SPECIALIST</h6>
        </div>

        <div class="num-col mt56">
          <div class="row">
            <img src="@/assets/images/num.png"/>
            负责公司国内外员工入、转、调、离手续办理；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            负责员工的合同签订及管理工作；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            负责员工信息管理，建立和维护人事档案、员工花名册，及时更新员工的个人信息和资料；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            大学本科及以上学历，人力资源、行政管理、或英语相关专业；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            经验不限，热爱人力资源工作，对人力资源工作有基本的认知；
          </div>
          <div class="row">
            <img src="@/assets/images/num.png"/>
            工作积极主动，有服务意识，愿意承担繁杂琐碎的事务性工作。
          </div>

        </div>
      </div>

      <div class="content-grid">


      </div>
    </div>

    <Footer ></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";

export default {
  name: "home",
  components: {pageTop, Footer},
  data() {
    return {
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: []
    };
  },
  created() {
    const fetchProducts = this.request
      .get("/products")
      .then(response => {
        this.products = response;
      })
      .catch();
    const fetchJobCategories = this.request
      .get("/job-categories")
      .then(response => {
        this.jobCategories = response;
      });
    this.request.get("/byte-standards").then(response => {
      this.byteStandards = response;
    });
    this.request.get("/staff-stories").then(response => {
      this.staffStories = response;
    });
  },
  methods: {
    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({ name: "jobs", params: { keyword } });
    },
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    }
  },
  mounted() {
    const rootVm = this.$root;
    rootVm.$emit(
      "home-scrolling",
      { directionX: 1, directionY: -1 },
      { x: document.body.scrollLeft, y: document.body.scrollTop }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
  },
  destroyed() {
    this.unwatch();
  }
};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>

</style>
